import {postRequest} from "../../utils/api"

export const getLessonVideoPageList = (params) => {
    return postRequest('/core/lesson/video/findList',params)
}

export const addLessonVideo = (params) => {
    return postRequest('/core/lesson/video/save',params)
}

export const updateLessonVideo = (params) => {
    return postRequest('/core/lesson/video/update',params)
}

export const deleteLessonVideo = (params) => {
    return postRequest('/core/lesson/video/delete',params)
}
